import { memo } from "react";
import Rating from "react-rating";
import styles from "../hotel.module.css";
import starColor from '../../icons/star-color.svg';
import userDefaultPhoto from '../../icons/userDefault.svg';
import starTransparent from '../../icons/star-transparent.svg';
import { formatDate, getReviewsFilter } from "../hotel.helper";
import Loading from "../../components/Loading/Loading";

export default memo(function Reviews({ order, reviews, reviewsLoading }) {
    const reviewsHotel = getReviewsFilter(order, reviews);
    return (
        <div style={{ position: 'relative' }}>
            {!reviewsLoading ? reviewsHotel?.map((review, index) => (
                <div key={index} style={{ marginBottom: "20px" }} className={styles.reviewComments}>
                    <p style={{ fontSize: '12px', color: "#858585" }}>{formatDate(review.createdAt)}</p>
                    <Rating
                        initialRating={Object.entries(review.Rates).reduce((sum, [key, value]) => sum + value.rates, 0) / 10}
                        stop={5}
                        emptySymbol={<img src={starTransparent} className={styles.starIcon} alt='' />}
                        fullSymbol={<img src={starColor} className={styles.starIcon} alt='' />}
                        readonly
                    />
                    <div className={styles.user}>
                        <img src={review.photo || userDefaultPhoto} alt={review?.username || 'user'} className={styles.userPicture} />
                        <p style={{ fontSize: "14px", fontWeight: '500' }}>{review?.User?.username || 'User'}</p>
                    </div>
                    <p>{review.comment}</p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginTop: "8px" }}>
                        {Object.entries(review.Rates.sort((a, b) => a.RateCriterium.name.localeCompare(b.RateCriterium.name)))?.map(([key, value]) => (
                            <div key={key}>
                                <p>{value.RateCriterium.name}: <strong>{value.rates}</strong> </p>
                            </div>
                        ))}
                    </div>
                    <hr style={{ margin: "24px 0", backgroundColor: "#eee", height: "1px", opacity: '0.3' }} />
                </div>
            )) : <Loading type='BarLoader' />}
        </div>
    )
})
